import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { BaseFacade } from '@core/classes/base.facade';
import { ExhibitionDto } from '@api/rest';
import * as fromExhibition from './_ngrx/exhibition.reducer';
import * as ExhibitionState from './_ngrx/exhibition.selectors'
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class ExhibitionFacade extends BaseFacade {
  private state$: Store<fromExhibition.State>;


  readonly allExhibitions$: Observable<ExhibitionDto[]> = this.takeAll(ExhibitionState.getExhibitions);
  readonly selected$: Observable<ExhibitionDto> = this.takeAll(ExhibitionState.getSelected);

  readonly selectedSignal = toSignal(this.selected$);
  readonly allExhibitionsSignal = toSignal(this.allExhibitions$);

  constructor() {
    const state$ = inject<Store<fromExhibition.State>>(Store);

    super(state$);

    this.state$ = state$;
  }

  get firstExhibitionAndTourId(): Observable<string[]> {
    return this.allExhibitions$
      .pipe(
        map(exhibitions => [exhibitions[0]?.id, exhibitions[0].tour_refs[0]])
      );
  }
}
